import PromptSection from './PromptSection';

export default PromptSection;
